export default __webpack_public_path__ + "static/media/wallpaper-2.1d590651.png";